<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-21 11:03:44
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
          <div class="pageTitle">经销商窜货统计</div>
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <el-tab-pane label="窜货经销商统计" name="first">
                <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                    <el-form-item label="经销商:">
                        <el-col :span="19">
                            <el-input v-model="form1.dealer_name" clearable readonly></el-input>
                        </el-col>
                        <el-col :span="4" style="margin-left: 10px;">
                            <el-button type="primary" @click="selectDealer()">选择</el-button>
                        </el-col>

                    </el-form-item>
                    <el-form-item label="经销商级别:">
                        <el-select v-model="form1.from_level_id" placeholder="请选择经销商级别" clearable>
                            <el-option v-for=" i in dealerLevel" :key="i.id" :label="i.level_name"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getDealerList()">搜索</el-button>
                        <el-button type="primary" @click="dealerExport()">导出</el-button>
                    </el-form-item>

                </el-form>
                <span style="margin: 0 20px">总窜货数量:</span><span style="color: red;">{{feeling_goods_total}}</span>
                <!--表格-->
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 95%;margin: 20px">
                    <el-table-column
                            prop="from_name"
                            label="窜货经销商名称"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="from_sn"
                            label="窜货经销商编号"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            prop="from_level_name"
                            label="经销商级别"
                            show-overflow-tooltip>
                       <!-- <template slot-scope="scope">
                           <span v-if="scope.row.from_type == 1">总部</span>
                           <span v-if="scope.row.from_type == 2">经销商</span>
                           <span v-if="scope.row.from_type == 3">门店</span>
                        </template>-->
                    </el-table-column>
                    <el-table-column
                            prop="return_goods_num_total"
                            label="窜货总数量"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail1(scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="窜货商品统计" name="second">
                <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
                    <el-form-item label="产品信息:">
                        <el-input v-model="form2.keywords" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getGoodsList">搜索</el-button>
                        <el-button type="primary" @click="productExport()">导出</el-button>
                    </el-form-item>

                </el-form>
                <span style="margin: 0 20px">总窜货次数:</span><span style="color: red;">{{totalSize2}}</span>
                <el-table
                        ref="multipleTable"
                        :data="tableData2"
                        v-loading="loading"
                        border
                        style="width: 95%;margin: 20px">
                    <el-table-column
                            prop="product_id"
                            label="产品编号"
                            fixed>
                    </el-table-column>
                    <el-table-column
                            prop="product_name"
                            label="产品名称"
                            show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                            prop="product_specs"
                            label="规格"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="product_unit"
                            label="单位"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="return_goods_num_total"
                            label="窜货数量"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="detail2(scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="窜货出货订单统计" name="three">
                <fleeingOrderCount />
            </el-tab-pane>
        </el-tabs>
        <!--选择经销商-->
        <selectDealer
                v-if="selectDealerDialog"
                v-on:handleClose='selectDealerDialog = false'
                @pushData="getDealerInfo">
        </selectDealer>
        <!--窜货经销商统计明细-->
        <dealerCountDetail
                v-if="dealerCountDetailDialog"
                v-on:handleClose='dealerCountDetailDialog = false'
                :dealerData="dealerData"
        >
        </dealerCountDetail>
        <!--窜货商品统计-->
        <productCountDetail
                v-if="productCountDetailDialog"
                v-on:handleClose='productCountDetailDialog = false'
                :productData="productData"
        >
        </productCountDetail>
    </div>
</template>
<script>
    import selectDealer from '../../common/selectDealer';
    import dealerCountDetail from './dealerCountDetail';
    import productCountDetail from './productCountDetail';
    import fleeingOrderCount from './components/fleeingOrderCount'
    export default {
        name: "fleeing-count",
        data() {
            return {
                loading:false,
                selectDealerDialog: false,
                dealerCountDetailDialog: false,
                productCountDetailDialog: false,
                activeName2: 'first',
                form1: {
                    from_sn: '',
                    dealer_name: '',
                    from_level_id: '',
                },
                form2: {
                    keywords: ''
                },
                tableData1: [],
                tableData2: [],
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
                dealerLevel: [],//经销商级别
                dealerData: {},//窜货经销商传值
                productData: {},//窜货产品传值
                feeling_goods_total:''
            }
        },
        methods:
            {
                getLastMonth() {
                    var now = new Date();
                    var year = now.getFullYear();//getYear()+1900=getFullYear()
                    var month = now.getMonth() + 1;//0-11表示1-12月
                    var day = now.getDate();
                    var dateObj = {};
                    if (parseInt(month) < 10) {
                        month = "0" + month;
                    }
                    if (parseInt(day) < 10) {
                        day = "0" + day;
                    }

                    dateObj.now = year + '-' + month + '-' + day;

                    if (parseInt(month) == 1) {//如果是1月份，则取上一年的12月份
                        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
                        return dateObj;
                    }

                    var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//上月总天数
                    if (preSize < parseInt(day)) {//上月总天数<本月日期，比如3月的30日，在2月中没有30
                        dateObj.last = year + '-' + month + '-01';
                        return dateObj;
                    }

                    if (parseInt(month) <= 10) {
                        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    } else {
                        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
                        return dateObj;
                    }

                },
                //获取经销商级别
                getDealerLevel() {
                    this.$get('logistics', '/dealers.level', {}).then(res => {
                        //console.log(res);
                        this.dealerLevel = res.data;
                    }).catch(function (error) {
                        console.log(error);
                    });
                },
                //选择经销商
                getDealerInfo(val) {
                    this.form1.from_sn = val.dealer_sn;
                    this.form1.dealer_name = val.dealer_name;
                },
                //获取窜货经销商列表
                getDealerList() {
                    this.loading = true;
                    this.$get('logistics', '/feelinggoods/dealers', {
                        lang: '',
                        from_sn: this.form1.from_sn,
                        from_level_id: this.form1.from_level_id,
                        per_page: this.pageSize1,
                        page: this.pageNo1
                    }).then(res => {
                        this.loading = false;

                        this.tableData1 = res.data;
                        this.totalSize1 = res.meta.total;
                        this.feeling_goods_total = res.feeling_goods_total;
                    }).catch(function (error) {
                        this.loading = false;

                        console.log(error);
                    });

                },
                //窜货经销商导出
                dealerExport(){
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
               
                    window.open(this.$Base_Export
                        +'/feelinggoods/dealers.export?from_sn=' + this.form1.from_sn+'&is_export=1' +'&from_level_id=' + this.form1.from_level_id+'&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                    )
                },
                //获取窜货产品列表
                getGoodsList() {
                    this.loading = true;
                    this.$get('logistics', '/feelinggoods/products', {
                        lang: '',
                        keywords: this.form2.keywords,
                        per_page: this.pageSize2,
                        page: this.pageNo2
                    }).then(res => {
                       // console.log(res);
                        this.loading = false;

                        this.tableData2 = res.data;
                        this.totalSize2 = res.meta.total;
                    }).catch(function (error) {
                        this.loading = false;

                        console.log(error);
                    });
                },
                //窜货商品导出
                productExport(){
                    let url = '',access_tokens = localStorage.getItem('access_tokens');
          

                    window.open(this.$Base_Export
                        +'/feelinggoods/products.export?keywords=' + this.form2.keywords +'&is_export=1'+ '&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                    )
                },
                //选择经销商
                selectDealer() {
                    this.selectDealerDialog = true;
                },
                //窜货经销商统计明细
                detail1(row) {
                    this.dealerData = row;
                    this.dealerCountDetailDialog = true;
                },
                //窜货产品统计
                detail2(row) {
                    this.productData = row;
                    this.productCountDetailDialog = true;
                },
                handleClick(tab) {
                    //console.log(tab.label);
                    if (tab.label == '窜货经销商统计') {
                        this.getDealerList();
                    } else {
                        this.getGoodsList();
                    }
                },
                handleSizeChange1(val) {
                    this.pageSize = val;
                    this.pageNo1 = 1;
                    this.getDealerList();
                },
                handleCurrentChange1(val) {
                    console.log(val)
                    this.pageNo1 = val;
                    this.getDealerList();
                },
                handleSizeChange2(val) {
                    this.pageSize = val;
                    this.pageNo2 = 1;
                    this.getGoodsList();
                },
                handleCurrentChange2(val) {
                    this.pageNo2 = val;
                    this.getGoodsList();
                },
            },
        created() {
            this.getDealerLevel();
            this.getDealerList();
        },
        components: {
            selectDealer, dealerCountDetail, productCountDetail,fleeingOrderCount
        }
    }
</script>

<style lang="scss" scoped>

</style>